module.exports = __webpack_public_path__ + "static/media/accordion-circle-open.d847388c.svg";